export interface AgencyTopicsConfig {
  agencyTopics: {
    [key: string]: string[];
    default: string[];
  };
}

export const agencyTopicsConfig: AgencyTopicsConfig = {
  agencyTopics: {
    "25": [
      "Company culture",
      "Compensation", 
      "Leadership",
      "Training or education",
      "Schedule",
      "Patient caseload",
      "Commute or travel",
      "Other",
      "Attempt no answer"
    ],
    default: [
      "Low Caseload",
      "Schedule",
      "Care Coordination",
      "Pay",
      "CFSS Communication",
      "Documentation",
      "Access to Training",
      "Driving",
      "Clinical Growth Opportunity",
      "Orientation",
      "High Caseload"
    ]
  }
};

// Helper function to get topics based on agency ID
export const getTopicsForAgency = (agencyId: number | string | undefined): string[] => {
  const agencyKey = agencyId?.toString();
  return (agencyKey && agencyTopicsConfig.agencyTopics[agencyKey]) || agencyTopicsConfig.agencyTopics.default;
}; 